import React from 'react';
import { Link, useParams, useLocation} from 'react-router-dom';
import { Subtract } from 'assets/images/web-isn';

const BreadcrumbAboutIsn = props => {
  const {language} = useParams();
  const location = useLocation();
  return (
    <div>
      <div className="container">
        <div className="row breadcrumb align-items-center px-0">
          <div className="col-12">
            <div className="breadcrumb-item row">
              <ul>
                {props.breadCrumb && props.breadCrumb.length
                  ? props.breadCrumb.map((item, index) => {
                      return (
                        <li key={index} className={language === 'en'? 'text-capitalize': ''}>
                          {index === 0 ? (
                            <Link to={`/${language}${item.url}`}>{item.title}</Link>
                          ) : index === props.breadCrumb.length - 1 ? (
                            <>
                              <img src={Subtract} alt="subtract" style={{marginBottom: 4}}/>
                              <span className="active">{item.title}</span>
                            </>
                          ) : (
                            <>
                              <img src={Subtract} alt="subtract" style={{marginBottom: 4}}/>
                              {location.pathname.includes("/about-us/housing-material/overview") && index === props.breadCrumb.length - 2 ? 
                                <span className="no-click">{item.title}</span>
                                :
                                <Link to={`/${language}${item.url}`}>{item.title}</Link>
                              }
                            </>
                          )}
                        </li>
                      );
                    })
                  : ''}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreadcrumbAboutIsn;
